import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { SelectOption } from "shared/types/Select"
import { WithClassName } from "shared/types/WithClassName"
import { Select } from "shared/ui/input/select/select/Select"

export interface ProjectPositionInputProps extends WithClassName {
  name: string
  options: SelectOption<number>[] | undefined
  readonly?: boolean
  loading?: boolean
  disabled?: boolean
}

export const ProjectPositionInput = React.memo(
  ({ className, options, ...rest }: ProjectPositionInputProps) => {
    const { t } = useTranslation()
    return (
      <Select.Root
        label={t("ProjectChild.Position")}
        data-testid="project-position-input"
        className={classNames("project-position-input", className)}
        {...rest}
      >
        <Select.Label />
        <Select.Input options={options} />
        <Select.ErrorMessage />
      </Select.Root>
    )
  }
)
